module.exports = __webpack_public_path__ + "static/media/IIT_PKD_short logo_RGB.a2f7ae4b.jpg";